import { Box, Typography } from '@mui/material'
import React from 'react'

interface LanguageToggleProps {
    currentLocale: 'en' | 'ar'
    onToggle: () => void
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({ currentLocale, onToggle }) => {
    const isEnglish = currentLocale === 'en'

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: (t) => `${t.palette.primary.A100}`,
                borderRadius: '25px',
                overflow: 'hidden',
                minWidth: 110,
                height: 34,
                py: 0.5,
                px: 0.5
            }}
        >
            {/* ENG Option */}
            <Box
                onClick={onToggle}
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: isEnglish ? '#FFFFFF' : 'transparent',
                    color: '#1a2a3a',
                    fontWeight: 500,
                    fontSize: 12,
                    py: 0.5,
                    px: 0.5,
                    transition: 'background-color 0.2s',
                    borderRadius: isEnglish ? '20px' : '0',
                    cursor: 'pointer',
                    '&:hover': {
                        bgcolor: isEnglish ? '#FFFFFF' : '#D0E8F0'
                    }
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: 12,
                        color: '#1a2a3a',
                        textTransform: 'none',
                        userSelect: 'none'
                    }}
                >
                    ENG
                </Typography>
            </Box>

            {/* Separator */}
            <Box
                sx={{
                    width: '1px',
                    height: '24px',
                    bgcolor: (t) => `${t.palette.primary.main}`,
                    flexShrink: 0,
                    mx: 0.5
                }}
            />

            {/* Arabic Option */}
            <Box
                onClick={onToggle}
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: !isEnglish ? '#FFFFFF' : 'transparent',
                    color: '#1a2a3a',
                    fontWeight: 500,
                    fontSize: 12,
                    py: 0.5,
                    px: 0.5,
                    transition: 'background-color 0.2s',
                    borderRadius: !isEnglish ? '20px' : '0',
                    cursor: 'pointer',
                    '&:hover': {
                        bgcolor: !isEnglish ? '#FFFFFF' : '#D0E8F0'
                    }
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: 14,
                        color: '#1a2a3a',
                        textTransform: 'none',
                        userSelect: 'none'
                    }}
                >
                    العربية
                </Typography>
            </Box>
        </Box>
    )
}

export type { LanguageToggleProps }
